export default __webpack_public_path__ + "static/media/budget-analysis-icon.9b03bf07.svg";